const STORAGE_PREFIX = 'connector_eval_job:';

export function evaluationJobStorageKey(integrationId: string): string {
  return `${STORAGE_PREFIX}${integrationId}`;
}

export function readPersistedEvaluationJobId(integrationId: string | null | undefined): string | null {
  if (!integrationId) return null;
  try {
    const raw = sessionStorage.getItem(evaluationJobStorageKey(integrationId));
    if (!raw?.trim()) return null;
    return raw.trim();
  } catch {
    return null;
  }
}

export function persistEvaluationJobId(integrationId: string, jobId: string): void {
  try {
    sessionStorage.setItem(evaluationJobStorageKey(integrationId), jobId.trim());
  } catch {
    // ignore quota / private mode
  }
}

export function clearPersistedEvaluationJobId(integrationId: string | null | undefined): void {
  if (!integrationId) return;
  try {
    sessionStorage.removeItem(evaluationJobStorageKey(integrationId));
  } catch {
    // ignore
  }
}
